import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/** Global map: tenant user id → has ≥1 live agent socket (see frontend-user-presence.md). */
type UserPresenceState = {
  byUserId: Record<string, boolean>;
};

const initialState: UserPresenceState = {
  byUserId: {},
};

const userPresenceSlice = createSlice({
  name: 'userPresence',
  initialState,
  reducers: {
    mergeBootstrap(state, action: PayloadAction<Record<string, boolean>>) {
      state.byUserId = { ...state.byUserId, ...action.payload };
    },
    setUserOnline(state, action: PayloadAction<{ userId: string; online: boolean }>) {
      const { userId, online } = action.payload;
      if (!userId) return;
      state.byUserId[userId] = online;
    },
    clearUserPresence() {
      return initialState;
    },
  },
});

export const { mergeBootstrap, setUserOnline, clearUserPresence } = userPresenceSlice.actions;

export default userPresenceSlice.reducer;

/** Narrow root slice for selectors (avoids circular import with store). */
type UserPresenceRoot = { userPresence: UserPresenceState };

export const selectUserPresenceMap = (state: UserPresenceRoot) => state.userPresence.byUserId;

export function selectIsUserOnline(userId: string | undefined | null) {
  return (state: UserPresenceRoot) =>
    !!(userId && typeof userId === 'string' && state.userPresence.byUserId[userId]);
}
